import instanceAxios from '@/util/axios';
import { GetTagsRequest, GetTagsResponse } from './getTags.types';
import { getTagsUrl } from '@/constants';

export async function getTags(params?: GetTagsRequest): Promise<GetTagsResponse> {
  const response = await instanceAxios.get<GetTagsResponse>(getTagsUrl, { params });
  return response.data;
}
